// src/slices/menuSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// ✅ Fetch categories (POST with user_id from Redux)
export const fetchCategories = createAsyncThunk(
  "menu/fetchCategories",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { user } = getState().auth || {}; // ✅ Access Redux auth state
      const userId = user?.id || 0;
      const dinein = JSON.parse(localStorage.getItem("dinein"));

      const res = await axios.post(`${window.BASE_API_URL}category`, {
        user_id: userId,
         dinein : dinein?.apptype
      });

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ✅ Fetch menu items by category ID
export const fetchMenuItems = createAsyncThunk(
  "menu/fetchMenuItems",
  async (categoryId, { getState, rejectWithValue }) => {
    try {
      // ✅ Access Redux auth state
      const { user } = getState().auth || {};
      const userId = user?.id || 0;
  const dinein = JSON.parse(localStorage.getItem("dinein"));
      // ✅ Make POST request instead of GET
      const res = await axios.post(`${window.BASE_API_URL}getmenubycategoryid`, {
        categoryId,
        userId, // send consistent key name
        dinein : dinein?.apptype
      });

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


const menuSlice = createSlice({
  name: "menu",
  initialState: {
    categories: [],
    menuItems: [],
    selectedCatId: null,
    loading: false,
    error: null,
  },
  reducers: {
    setSelectedCatId(state, action) {
      state.selectedCatId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // 🔹 Fetch categories
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.categories = action.payload;
        state.selectedCatId = action.payload[0]?.id || null;
        state.loading = false;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      // 🔹 Fetch menu items
      .addCase(fetchMenuItems.fulfilled, (state, action) => {
        state.menuItems = action.payload;
      });
  },
});

export const { setSelectedCatId } = menuSlice.actions;
export default menuSlice.reducer;
